import React, { useContext, useState, useCallback } from 'react';

import { DefaultAutomationMacros, MacroNutrient } from '../../../../../../utils/meals';
import { SaveButton } from '../../../../../../../components/Button/ActionButtons';
import { StyledTextField } from '../../../../../../../components/Inputs';
import MealPlanContext from '../../../../../../context/MealPlanContext';
import useToast from '../../../../../../hooks/useToast';
import EditItem from '../../../../components/EditItem';
import {
  SettingContainer,
  StyledTitledActionContainerSection,
  StyledTypography,
} from '../styles';

import texts from './texts.json';

const AutomationMacroPercentages = () => {
  const {
    mealPlanConfig,
    saveMealPlanConfig,
  } = useContext(MealPlanContext);

  const { showToast } = useToast();

  const automationMacros = mealPlanConfig?.automationMacros || DefaultAutomationMacros;

  const [macros, setMacros] = useState(automationMacros);

  const isSavable = Number(macros[MacroNutrient.PROTEIN]) !== automationMacros[MacroNutrient.PROTEIN]
    || Number(macros[MacroNutrient.CARBS]) !== automationMacros[MacroNutrient.CARBS]
    || Number(macros[MacroNutrient.FAT]) !== automationMacros[MacroNutrient.FAT];

  const handleValueChange = useCallback((name) => (event) => {
    setMacros((current) => ({ ...current, [name]: event.target.value }));
  }, []);

  const handleSave = useCallback(() => {
    const total = Number(macros[MacroNutrient.PROTEIN])
      + Number(macros[MacroNutrient.CARBS])
      + Number(macros[MacroNutrient.FAT]);
    if (total !== 100) {
      showToast(texts.errors.sumError, { error: true });
      return;
    }

    saveMealPlanConfig({
      automationMacros: {
        protein: Number(macros[MacroNutrient.PROTEIN]),
        carbs: Number(macros[MacroNutrient.CARBS]),
        fat: Number(macros[MacroNutrient.FAT]),
      },
    });
    showToast(texts.saved);
  }, [macros, saveMealPlanConfig, showToast]);

  return (
    <StyledTitledActionContainerSection>
      <StyledTypography>{texts.description}</StyledTypography>
      <SettingContainer $row $top>
        <EditItem label={texts.proteinLabel}>
          <StyledTextField
            value={macros[MacroNutrient.PROTEIN]}
            onChange={handleValueChange(MacroNutrient.PROTEIN)}
            type="number"
            title={texts.percentTitle}
          />
        </EditItem>
        <EditItem label={texts.carbsLabel}>
          <StyledTextField
            value={macros[MacroNutrient.CARBS]}
            onChange={handleValueChange(MacroNutrient.CARBS)}
            type="number"
            title={texts.percentTitle}
          />
        </EditItem>
        <EditItem label={texts.fatLabel}>
          <StyledTextField
            value={macros[MacroNutrient.FAT]}
            onChange={handleValueChange(MacroNutrient.FAT)}
            type="number"
            title={texts.percentTitle}
          />
        </EditItem>
      </SettingContainer>
      <SaveButton
        onClick={handleSave}
        disabled={!isSavable}
      >
        {texts.save}
      </SaveButton>
    </StyledTitledActionContainerSection>
  );
};

export default AutomationMacroPercentages;
